import { setRoute } from '../../routes/actions/set';

export function request(id, name, silently) {
    id = parseInt(id, 10);

    return (dispatch, getState) => {
        if (isNaN(id)) {
            return
        }

        dispatch({
            type: 'AUDITS_OPEN_REQUEST',
            id,
            name
        });

        if (!silently) {
            dispatch(setRoute('audits:' + id, {}));
            dispatch(setRoute('*global:audits:' + id, {}));
        }
    };
}

export function error(id, errors) {
    id = parseInt(id, 10);

    return {
        type: 'AUDITS_OPEN_ERROR',
        id,
        errors
    };
}

export function finish(id, { audits }) {
    let audit = audits[0] || {};

    return (dispatch) => {

        dispatch({
            type: 'AUDITS_OPEN_FINISH',
            id: parseInt(id, 10),
            audit
        });
    };
}

export function clear() {
    return {
        type: 'AUDITS_OPEN_CLEAR'
    };
}
